<template>
  <div>
    <b-form @submit.prevent="submitForm">
      <!-- ข้อมูลการซ่อม -->
      <div class="form-sectiontest">
        <div v-if="!fix.id">
          <div class="form-container">
            <div class="form-section">
              <h5 class="section-title">
                {{ $t('fixinfo') }}
              </h5>
              <div class="form-row">
                <b-form-group :label="$t('typefix')">
                  <b-form-select
                    v-model="form.categoryId"
                    :options="categoriesOptions"
                    required
                    class="input-box"
                    @change="fetchSubcategories"
                  />
                </b-form-group>
                <b-form-group :label="$t('subcatefix')">
                  <b-form-select
                    v-model="form.subcategoryId"
                    :options="subcategoriesOptions"
                    :disabled="isLoadingfix || !form.categoryId"
                    required
                    class="input-box"
                  />
                  <b-spinner
                    v-if="isLoadingfix"
                    variant="border"
                    small
                  />
                </b-form-group>
                <b-form-group :label="$t('locationname')">
                  <b-form-select
                    v-model="form.locationId"
                    :options="locationsOptions"
                    class="input-box"
                    required
                  />
                </b-form-group>
                <b-form-group :label="$t('phone')">
                  <b-form-input
                    v-model="form.phone"
                    maxlength="20"
                    class="input-box"
                    :placeholder="$t('phoneinput')"
                  />
                </b-form-group>
				<b-form-group :label="$t('sn')">
                  <b-form-input
                    v-model="form.sn"
                    maxlength="40"
                    class="input-box"
                    :placeholder="$t('sninput')"
                  />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
		
		 <div v-if="fix.id">
          <div class="form-container">
            <div class="form-section">
              <h5 class="section-title">
                {{ $t('fixinfo') }}
              </h5>
              <div class="form-row">
                <b-form-group :label="$t('sn')">
                  <b-form-input
                    v-model="form.sn"
                    maxlength="40"
                    class="input-box"
                    :placeholder="$t('sninput')"
                  />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>


        <!-- ข้อมูลค่าใช้จ่าย -->
        <div
          v-if="form.fixId"
          class="form-section"
        >
          <h5 class="section-title">
            {{ $t('expenseinfo') }}
          </h5>
          <b-button @click="addexpense">
            {{ $t('addexpense') }}
          </b-button>

          <div
            v-if="isLoading.expenses"
            class="text-center"
          >
            <b-spinner label="Loading..." />
          </div>

          <div v-else>
            <b-modal
              v-model="showExpenseModal"
              :title="$t('expenseinfo')"
            >
              <div class="form-section">
                <h5 class="section-title">
                  {{ $t('expenseinfo') }}
                </h5>
                <div class="form-row">
                  <b-form-group :label="$t('selectcateexpense')">
                    <b-form-select
                      v-model="expenseForm.expenseSubcateId"
                      required
                      :select-size="4"
                      class="input-box"
                      @change="onSubcategoryChange"
                    >
                      <b-form-select-option
                        v-for="(option, index) in formattedOptions"
                        :key="`${option.value}-${index}`"
                        :value="option.value"
                        :class="option.isCategory ? 'category-option' : 'subcategory-option'"
                        :disabled="option.isCategory"
                      >
                        {{ option.text }}
                      </b-form-select-option>
                    </b-form-select>
                    <b-alert
                      v-if="isSubcategoryRequired"
                      variant="danger"
                      show
                    >
                      {{ $t('confirminput') }}
                    </b-alert>
                  </b-form-group>

                  <b-form-group :label="$t('expense')">
                    <b-form-input
                      v-model.number="expenseForm.cost"
                      type="number"
                      step="0.01"
                      class="input-box"
                      placeholder="0.00"
                      @keydown="limitInputexpenseForm"
                    />
                  </b-form-group>

                  <b-form-group :label="$t('quantity')">
                    <b-form-input
                      v-model.number="expenseForm.quantity"
                      type="text"
                      step="1"
                      class="input-box"
                      placeholder="1"
                      @keydown="limitQuantityInputexpenseForm"
                    />
                  </b-form-group>

                  <b-form-group :label="$t('unit')">
                    <b-form-select
                      v-model="expenseForm.unit"
                      :options="unitOptions"
                      class="input-box"
                      placeholder="-- เลือกหน่วย --"
                    />
                  </b-form-group>

                  <b-form-group :label="$t('remark')">
                    <b-form-textarea
                      v-model="expenseForm.note"
                      :placeholder="$t('remarkinput')"
                      rows="3"
                      class="input-text"
                      maxlength="50"
                      @input="checkexpenseLength"
                    />
                    <small class="form-text text-muted">{{ expenseForm.note.length }}/50 {{ $t('text') }}</small>
                    <b-alert
                      v-if="lengthexpenseExceeded"
                      variant="danger"
                      show
                    >
                      {{ $t('text50') }}
                    </b-alert>
                  </b-form-group>
                </div>
              </div>
              <template #modal-footer>
                <b-button
                  variant="secondary"
                  @click="showExpenseModal = false"
                >
                  {{ $t('cancel') }}
                </b-button>
                <b-button
                  variant="primary"
                  @click="saveExpense"
                >
                  {{ $t('confirm') }}
                </b-button>
              </template>
            </b-modal>

            <div style="max-height: 200px; overflow-y: auto;">
              <b-table
                :items="displayExpensesList"
                :fields="expenseFields"
                class="mt-3"
                bordered
              >
                <!-- แสดงชื่อของหมวดหมู่หลัก -->
                <template #cell(expenseCateName)="data">
                  <span>{{ data.item.expenseCateName }}</span>
                </template>

                <!-- แสดงชื่อของหมวดหมู่ย่อย -->
                <template #cell(expenseSubcateName)="data">
                  <span>{{ data.item.expenseSubcateName }}</span>
                </template>

                <template #cell(cost)="data">
                  <span>
                    {{ formatCurrencyCost(data.item.cost) }}
                  </span>
                </template>

                <template #cell(sum)="data">
                  {{ formatCurrency(data.item.sum || (data.item.quantity * data.item.cost)) }}
                </template>

                <template #cell(actions)="data">
                  <span v-if="data.item.cost !== 'รวม'">
                    <b-button
                      size="sm"
                      variant="warning"
                      class="btn-space"
                      @click="editExpense(data.item)"
                    >
                      <b-icon
                        icon="pencil"
                        aria-hidden="true"
                      />
                    </b-button>
                    <b-button
                      size="sm"
                      variant="danger"
                      class="btn-space"
                      @click="openDeleteModalexpense(data.item.expensefixId)"
                    >
                      <b-icon
                        icon="trash"
                        aria-hidden="true"
                      />
                    </b-button>
                  </span>
                </template>
              </b-table>

            </div>
            <div style="font-weight: bold; margin-top: 10px;">
              {{ $t('totalcost') }}: {{ totalCost }}
            </div>

          </div>
        </div>

        <!-- ข้อมูลรายละเอียดการซ่อม -->
        <div class="form-section">
          <h5 class="section-title">
            {{ $t('fixinfodetails') }}
          </h5>
          <div class="form-row">
            <div v-if="!fix.id">
              <b-form-group :label="$t('fixdetails')">
                <b-form-textarea
                  v-model="form.fixDetails.detail"
                  :placeholder="$t('fixdetailsinput')"
                  rows="3"
                  maxlength="150"
                  required
                  class="input-text"
                  @input="checkfixdetailsLength"
                />
                <small class="form-text text-muted">{{ form.fixDetails.detail.length }}/150 {{ $t('text') }}</small>
                <b-alert
                  v-if="lengthfixdetailsExceeded"
                  variant="danger"
                  show
                >
                  {{ $t('text150') }}
                </b-alert>
              </b-form-group>
            </div>
            <b-form-group :label="$t('reasondetails')">
              <b-form-textarea
                v-model="form.fixDetailsAdditional.fixdetail"
                :placeholder="$t('reasondetailsinput')"
                rows="3"
                class="input-text"
                maxlength="150"
                @input="checkfixdetailsAddLength"
              />
              <small class="form-text text-muted">{{ form.fixDetailsAdditional.fixdetail.length }}/150 {{ $t('text') }}</small>
              <b-alert
                v-if="lengthfixdetailsAddExceeded"
                variant="danger"
                show
              >
                {{ $t('text150') }}
              </b-alert>
            </b-form-group>

            <b-form-group :label="$t('solution')">
              <b-form-textarea
                v-model="form.fixsolution.soldetail"
                :placeholder="$t('solutioninput')"
                rows="3"
                class="input-text"
                maxlength="150"
                @input="checkfixsolutionAddLength"
              />
              <small class="form-text text-muted">{{ form.fixsolution.soldetail.length }}/150 {{ $t('text') }}</small>
              <b-alert
                v-if="lengthfixsolutionExceeded"
                variant="danger"
                show
              >
                {{ $t('text150') }}
              </b-alert>
            </b-form-group>
          </div>
        </div>

        <!-- ข้อมูลรายละเอียดหลังบ้าน -->
        <div class="form-section">
          <h5 class="section-title">
            {{ $t('admindetails') }}
          </h5>
          <div class="form-row">
            <b-form-group
              v-if="!form.fixId"
              :label="$t('user')"
            >
              <b-form-select
                v-model="form.userId"
                :options="usersOptions"
                :select-size="4"
                class="input-box"
                required
              />
            </b-form-group>

            <div
              v-if="loadingWorker"
              class="overlay"
            >
              <div class="loading-container">
                <b-spinner
                  label="Loading..."
                  class="spinner"
                />
                <p class="loading-text">
                  {{ $t('loading') }}
                </p>
              </div>
            </div>

            <b-form-group :label="$t('worker')">
              <b-form-select
                v-model="form.workerId"
                :options="workers"
                class="input-box"
                :select-size="4"
                :disabled="loadingWorker"
              />
            </b-form-group>
            <b-form-group :label="$t('operator')">
              <b-form-input
                v-model="form.operator"
                maxlength="50"
                class="input-box"
                :placeholder="$t('operatorinput')"
              />
            </b-form-group>
            <b-form-group :label="$t('requesttype')">
              <b-form-select
                v-model="form.notice"
                :options="noticesOptions"
                class="input-box"
                required
              />
            </b-form-group>

            <b-form-group :label="$t('status')">
              <b-form-select
                v-model="form.statusId"
                :options="localStatusOptions"
                class="input-box"
                required
              />
            </b-form-group>

            <!-- แสดงกล่องข้อความหมายเหตุเมื่อสถานะเป็น 4 -->
            <b-form-group
              v-if="form.statusId === 4"
              :label="$t('fixcancelDetails')"
            >
              <b-form-textarea
                v-model="form.cancelDetails"
                :placeholder="$t('fixcancelDetailsinput')"
                rows="3"
                class="input-textcancel"
                required
                maxlength="50"
                @input="checkcancelDetailsLength"
              />
              <small class="form-text text-muted">{{ form.cancelDetails.length }}/50 {{ $t('text') }}</small>
              <b-alert
                v-if="lengthcancelDetailsExceeded"
                variant="danger"
                show
              >
                {{ $t('text50') }}
              </b-alert>
            </b-form-group>
          </div>
          <div class="form-row">
            <b-form-group :label="$t('getfixjob')">
              <b-form-input
                v-model="form.timefixget"
                class="input-box"
                type="datetime-local"
              />
            </b-form-group>
            <b-form-group :label="$t('Expectedcompletion')">
              <b-form-input
                v-model="form.timefixtk"
                class="input-box"
                type="datetime-local"
              />
            </b-form-group>
          </div>

        </div>

        <!-- ข้อมูลภาพถ่าย -->
        <div class="form-section">
          <h5 class="section-title">
            {{ $t('imageinfo') }}
          </h5>
          <div v-if="!fix.id">
            <b-form-group :label="$t('addimage')">
              <b-form-file
                multiple
                class="input-image"
                @change="handleFileChange"
              />
            </b-form-group>
          </div>
          <b-form-group :label="$t('addimagefix')">
            <b-form-file
              multiple
              class="input-image"
              @change="handleFileChangeDone"
            />
          </b-form-group>
        </div>
        <div class="form-buttons">
          <b-button
            variant="secondary"
            @click="$emit('close')"
          >
            {{ $t('cancel') }}
          </b-button>
          <b-button
            type="submit"
            variant="primary"
          >
            {{ $t('submit') }}
          </b-button>
        </div>
      </div>
      <!--model ลบของ spare-->
      <b-modal
        v-model="showConfirmationModal"
        :title="$t('delconfirm')"
        :ok-title="$t('yes')"
        :cancel-title="$t('cancel')"
        @ok="deletespare"
      >
        <p class="my-4">
          {{ $t('confirmdelete') }}
        </p>
      </b-modal>

      <!--model ลบของ expense-->
      <b-modal
        v-model="showConfirmationModalexpense"
        :title="$t('delconfirm')"
        :ok-title="$t('yes')"
        :cancel-title="$t('cancel')"
        @ok="deleteExpense"
      >
        <p class="my-4">
          {{ $t('confirmdelete') }}
        </p>
      </b-modal>

      <div
        v-if="isLoadingSubmit"
        class="overlay"
      >
        <div class="loading-container">
          <b-spinner
            label="Loading..."
            class="spinner"
          />
          <p class="loading-text">
            {{ $t('loading') }}
          </p>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import apiAdmin from '@/services/admin'
import apiMst from '@/services/masterDate'
import apiSetting from '@/services/Setting'
import apiAuth from '@/services/auth'
import emailservice from '@/services/emailservice'

export default {
  props: {
    fix: { type: Object, default: () => ({}) },
    categories: { type: Array, default: () => [] },
    devicecategories: { type: Array, default: () => [] },
    subcategories: { type: Array, default: () => [] },
    devicesubcategories: { type: Array, default: () => [] },
    devices: { type: Array, default: () => [] },
    expenses: { type: Array, default: () => [] },
    users: { type: Array, default: () => [] },
    statusOptions: { type: Array, default: () => [] },
    locations: Array,
  },
  data() {
    return {
      form: {
        order: '',
        categoryId: null,
        subcategoryId: null,
        devicecategoryId: null,
        devicesubcategoryId: null,
        userId: null,
        deviceId: null,
        operator: '',
        statusId: null,
        timefix: '',
        timefixget: '',
        timefixtk: '',
        timefixdone: '',
        workerId: null,
        fixId: this.fix?.id || null,
        fixDetails: { detail: '' },
        fixDetailsAdditional: { fixdetail: '' },
        fixsolution: { soldetail: '' },
        notice: null,
        locationId: null,
        phone: '',
		sn: '',
      },
      expenseForm: {
        expenseCateId: null,
        expenseSubcateId: null,
        cost: '',
        note: '',
        quantity: '',
        unit: '',
      },
      spareForm: {
        list: '',
        purchase: '',
        quantity: '',
        cost: '',
        source: '',
        detail: '',
      },
      isLoading: {
        expenses: false,
        spares: false,
      },
      isLoadingData: true,
      isLoadingSubmit: false,
      subcategoriesOptions: [],
      categoriesOptions: this.categories.map(c => ({ value: c.id, text: c.nameCate })),
      devicecategoriesOptions: this.devicecategories.map(d => ({ value: d.id, text: d.name })),
      devicesOptions: [],
      devicesubcategoriesOptions: [],
      usersOptions: this.users.map(u => ({ value: u.id, text: u.username })),
      workers: [],
      localStatusOptions: [...this.statusOptions],
      spareOptions: [],
      expensesOptions: [],
      selectedFiles: [],
      selectedFilesDone: [],
      showExpenseModal: false,
      showSpareModal: false,
      lengthfixdetailsExceeded: false,
      lengthfixdetailsAddExceeded: false,
      lengthexpenseExceeded: false,
      lengthspareExceeded: false,
      lengthfixsolutionExceeded: false,
      lengthcancelDetailsExceeded: false,
      expensesList: [],
      formattedOptions: [],
      spareList: [],
      isLoadingfix: false,
      isLoadingDevice: false,
      isLoadingDeviceCate: false,
      loadingWorker: false,
      noticesOptions: [
        { value: 'เปลี่ยน', text: this.$t('change') },
        { value: 'ซ่อม', text: this.$t('fix') },
        { value: 'ตรวจสอบ', text: this.$t('check') },
      ],
      isSubcategoryRequired: false,
      showConfirmationModal: false,
      spareIdToDelete: null,
      showConfirmationModalexpense: false,
      expenseToDelete: null,
      locationsOptions: [],
      unitOptions: [
		  { value: 'ชิ้น', text: 'ชิ้น' },
		  { value: 'ตัว', text: 'ตัว' },
		  { value: 'ชุด', text: 'ชุด' },
		  { value: 'กล่อง', text: 'กล่อง' },
		  { value: 'แผ่น', text: 'แผ่น' },
		  { value: 'แท่ง', text: 'แท่ง' },
		  { value: 'ม้วน', text: 'ม้วน' },
		  { value: 'ขด', text: 'ขด' },
		  { value: 'ลิตร', text: 'ลิตร' },
		  { value: 'กิโลกรัม', text: 'กิโลกรัม' },
		  { value: 'กระป๋อง', text: 'กระป๋อง' },
		  { value: 'หลอด', text: 'หลอด' },
		  { value: 'ขวด', text: 'ขวด' },
		  { value: 'ถุง', text: 'ถุง' },
		  { value: 'ใบ', text: 'ใบ' },
		  { value: 'คู่', text: 'คู่' },
		  { value: 'เมตร', text: 'เมตร' },
		  { value: 'อื่นๆ', text: 'อื่นๆ' }
		],
    }
  },
  computed: {
    displayExpensesList() {
      if (this.expensesList.length === 0) {
        return this.expensesList
      }
      return [...this.expensesList]
    },
    totalCost() {
      const total = this.expensesList.reduce((sum, item) => sum + (parseFloat(item.sum || (item.quantity * item.cost)) || 0), 0)
      return this.formatCurrencyCost(total)
    },
    displaySpareList() {
      if (this.spareList.length === 0) {
        return this.spareList
      }
      return [...this.spareList]
    },
    totalSpareCost() {
      return this.spareList.reduce((total, item) => total + (item.cost || 0), 0).toFixed(2)
    },

    expenseFields() {
      return [
        { key: 'expenseCateName', label: this.$t('expenseCateName') },
        { key: 'expenseSubcateName', label: this.$t('expenseSubcateName') },
        { key: 'quantity', label: this.$t('quantity') },
        { key: 'unit', label: this.$t('unit') },
        { key: 'cost', label: this.$t('expense') },
        { key: 'sum', label: this.$t('sum') },
        { key: 'note', label: this.$t('remark') },
        { key: 'actions', label: this.$t('management'), sortable: false },
      ]
    },
    spareFields() {
      return [
        { key: 'orderlist', label: this.$t('orderlist') },
        { key: 'list', label: this.$t('list') },
        { key: 'purchase', label: this.$t('orderbuy') },
        { key: 'quantity', label: this.$t('amount') },
        { key: 'cost', label: this.$t('cost') },
        { key: 'source', label: this.$t('sourcespare') },
        { key: 'detail', label: this.$t('remark') },
        { key: 'actions', label: this.$t('management'), sortable: false },
      ]
    },

  },
  watch: {
    fix: {
      immediate: true,
      handler(newFix) {
        if (newFix) {
          this.initializeForm(newFix)
		  if(newFix.id){
		   this.checkheadconfirm()
		  }
        }
      },
      statusOptions: {
        immediate: true,
        handler(newOptions) {
          this.localStatusOptions = [...newOptions]
        },
      },
    },
    'form.devicecategoryId': function (newDeviceCategoryId) {
      if (newDeviceCategoryId) {
        this.fetchDeviceSubcategories()
      } else {
        this.resetDeviceFields()
      }
    },
    'form.devicesubcategoryId': function (newDeviceSubcategoryId) {
      if (newDeviceSubcategoryId) {
        this.fetchDevices()
      } else {
        this.devicesOptions = []
      }
    },
  },
  async created() {
    try {
      this.locationsOptions = this.locations ? this.locations.map(l => ({ value: l.id, text: l.locationName })) : []
      await Promise.all([
        this.fetchworker(),
        this.fetchstatus(),
        this.fetchExpenses(),
        this.fetchExpensesfix(),
        this.fetchspare(),
      ])
    } catch (error) {
      console.error('Error in created hook:', error)
    }
  },
  methods: {
    initializeForm(newFix) {
      this.form = {
        order: newFix.order || '',
        categoryId: newFix.category?.id || null,
        subcategoryId: newFix.subcategory?.id || null,
        devicecategoryId: newFix.device?.category?.id || null,
        devicesubcategoryId: newFix.device?.subcategory?.id || null,
        userId: newFix.user?.id || null,
        deviceId: newFix.device?.id || null,
        operator: newFix.operator || '',
        statusId: newFix.status?.id || null,
        workerId: newFix.workerId?.id || null,
        timefix: newFix.timefix ? this.convertToThaiTime(newFix.timefix) : '',
        timefixget: newFix.timefixget ? this.convertToThaiTime(newFix.timefixget) : '',
        timefixtk: newFix.timefixtk ? this.convertToThaiTime(newFix.timefixtk) : '',
        timefixdone: newFix.timefixdone ? this.convertToThaiTime(newFix.timefixdone) : '',
        notice: newFix.notice || null,
        fixDetails: Array.isArray(newFix.fixDetails) && newFix.fixDetails.length > 0
          ? { detail: newFix.fixDetails[0]?.detail || '', id: newFix.fixDetails[0]?.id || null }
          : { detail: '' },
        fixDetailsAdditional: Array.isArray(newFix.fixDetailsAdditional) && newFix.fixDetailsAdditional.length > 0
          ? { fixdetail: newFix.fixDetailsAdditional[0]?.fixdetail || '', id: newFix.fixDetailsAdditional[0]?.id || null }
          : { fixdetail: '', id: null },
        fixsolution: Array.isArray(newFix.fixsolution) && newFix.fixsolution.length > 0
          ? { soldetail: newFix.fixsolution[0]?.soldetail || '', id: newFix.fixsolution[0]?.id || null }
          : { soldetail: '', id: null },
        locationId: newFix.location?.id || null,
        phone: newFix.phone || '',
        fixId: newFix.id || null,
        cancelDetails: newFix.cancelDetails || '',
		confirmedByhead: newFix.confirmedByhead?.id || null,
		sn: newFix.sn || '',
      }
      this.fetchSubcategoriesIfNeeded()
    },
    convertToThaiTime(utcDate) {
      const date = new Date(utcDate)
      date.setHours(date.getHours() + 7) // เพื่ม 7 ชั่วโมง
      return date.toISOString().slice(0, 16)
    },
    convertToUtcTime(localDate) {
      if (!localDate) return null
      const date = new Date(localDate)
      if (isNaN(date.getTime())) {
        console.error('Invalid date value:', localDate)
        return null
      }
      return date.toISOString()
    },
    fetchSubcategoriesIfNeeded() {
      if (this.form.categoryId) this.fetchSubcategories()
      if (this.form.subcategoryId) this.fetchDevices()
      if (this.form.devicecategoryId) this.fetchDeviceSubcategories()
      if (this.form.devicesubcategoryId) this.fetchDevices()
      if (this.form.workerId) this.fetchworker()
      if (this.form.expenseCateId) this.fetchExpenses()
      if (this.form.statusId) this.fetchstatus()
    },
    resetDeviceFields() {
      this.devicesubcategoriesOptions = []
      this.devicesOptions = []
    },
    handleFileChange(event) {
      this.selectedFiles = Array.from(event.target.files)
    },
    handleFileChangeDone(event) {
      this.selectedFilesDone = Array.from(event.target.files)
    },
    handleEdit(item) {
      console.log('Data item:', item)
      this.editExpense(item)
    },
    async uploadFiles(url, files) {
      if (files.length === 0) return
      const formData = new FormData()
      files.forEach(file => formData.append('files', file))
      formData.append('fixId', this.form.order || '')

      try {
        const response = await apiAdmin.post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        return response.data
      } catch (error) {
        console.error('Error uploading files:', error)
        alert('เกิดข้อผิดพลาดในการอัปโหลดไฟล์')
        throw error
      }
    },

    formatCurrency(value) {
      if (isNaN(value)) return '0.00 ฿'
      return `${new Intl.NumberFormat('th-TH', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)} ฿`
    },

    formatCurrencyCost(value) {
      if (isNaN(value)) return '0.00 ฿'
      return `${new Intl.NumberFormat('th-TH', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)} ฿`
    },

    editspare(spare) {
      if (!spare) return

      this.spareForm.spareId = spare.id
      this.spareForm.list = spare.list || ''
      this.spareForm.purchase = spare.purchase || ''
      this.spareForm.quantity = spare.quantity || ''
      this.spareForm.cost = spare.cost || 0
      this.spareForm.source = spare.source || ''
      this.spareForm.detail = spare.detail || ''
      this.showSpareModal = true
    },

    openDeleteModal(spareId) {
      this.spareIdToDelete = spareId
      this.showConfirmationModal = true
    },

    deletespare() {
      apiAdmin.delete(`/spareDel/${this.spareIdToDelete}`)
        .then(() => {
          this.fetchspare()
          this.showConfirmationModal = false
        })
        .catch(error => {
          console.error('Error deleting spare:', error)
          this.showConfirmationModal = false
        })
    },

    clearspareForm() {
      this.spareForm.spareId = null
      this.spareForm.list = ''
      this.spareForm.purchase = ''
      this.spareForm.quantity = 0
      this.spareForm.cost = 0
      this.spareForm.source = ''
      this.spareForm.detail = ''
    },

    editExpense(expense) {
      if (!expense) return
      this.expenseForm.expenseId = expense.expenseId
      this.expenseForm.expensefixId = expense.expensefixId
      this.expenseForm.expenseSubcateId = expense.expenseSubcateId
      this.expenseForm.cost = expense.cost || 0
      this.expenseForm.note = expense.note || ''
      this.expenseForm.quantity = expense.quantity || ''
      this.expenseForm.unit = expense.unit || ''
      this.showExpenseModal = true
    },

    addexpense() {
      this.clearExpenseForm()
      this.showExpenseModal = true
    },
    addspare() {
      this.clearspareForm()
      this.showSpareModal = true
    },

    openDeleteModalexpense(expense) {
      this.expenseToDelete = expense
      this.showConfirmationModalexpense = true
    },

    deleteExpense() {
      apiAdmin.delete(`/expensefixDel/${this.expenseToDelete}`)
        .then(() => {
          this.fetchExpensesfix()
          this.showConfirmationModalexpense = false
        })
        .catch(error => {
          console.error('Error deleting Expense:', error)
          this.showConfirmationModalexpense = false
        })
    },

    clearExpenseForm() {
      this.expenseForm.expenseCateId = null
      this.expenseForm.expenseSubcateId = null
      this.expenseForm.expensefixId = null
      this.expenseForm.cost = ''
      this.expenseForm.note = ''
      this.expenseForm.quantity = ''
      this.expenseForm.unit = ''
    },

    async submitForm() {
      this.isLoadingSubmit = true
      try {
        const fixResponse = await this.saveFix()
        if (!fixResponse || !fixResponse.data || !fixResponse.data.id) {
          throw new Error('ไม่สามารถหา fixId ได้')
        }
        this.form.fixId = fixResponse.data.id
        this.form.order = fixResponse.data.order

        await Promise.all([
          this.uploadFiles('/uploads', this.selectedFiles),
          this.uploadFiles('/uploadsdone', this.selectedFilesDone),
        ])

        await this.saveFixDetail()
        await this.saveFixDetailAdd()
        await this.savesolution()
		await this.checkheadconfirm()

        if ([4, 5].includes(this.form.statusId)) {
          const Emails = await this.fetchEmails(this.form.userId)
          if (!Emails || Emails.length === 0) {
            throw new Error('ไม่พบอีเมลผู้ใช้')
          }
          await this.sendEmailNotification(Emails, this.form)
        } else if (this.form.statusId === 1 || this.form.statusId === 2 || this.form.statusId === 3) {
          const Emails = ['admin@fukuyama-gl.com']
          if (!Emails || Emails.length === 0) {
            throw new Error('ไม่พบอีเมลผู้ดูแลงานซ่อม')
          }
          await this.sendEmailNotification(Emails, this.form)
        }

        this.$emit('fix-saved')
        this.$emit('close')
      } catch (error) {
        console.error('Error saving data:', error)
        alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล')
      } finally {
        this.isLoadingSubmit = false
      }
    },

    async saveFix() {
      const payload = {
        order: this.form.order,
        status: { id: this.form.statusId },
        timefix: this.form.timefix ? this.convertToUtcTime(this.form.timefix) : null,
        timefixget: this.form.timefixget ? this.convertToUtcTime(this.form.timefixget) : null,
        timefixtk: this.form.timefixtk ? this.convertToUtcTime(this.form.timefixtk) : null,
        timefixdone: this.form.statusId === 5 || this.form.statusId === 4 ? this.convertToUtcTime(new Date().toISOString()) : this.form.timefixdone ? this.convertToUtcTime(this.form.timefixdone) : null,
        operator: this.form.operator,
        user: { id: this.form.userId },
        category: { id: this.form.categoryId },
        subcategory: { id: this.form.subcategoryId },
        workerId: this.form.workerId ? { id: this.form.workerId } : null,
        cancelDetails: this.form.cancelDetails,
        notice: this.form.notice,
        location: { id: this.form.locationId },
        phone: this.form.phone || null,
		confirmedByhead: !!this.form.confirmedByhead,
		sn: this.form.sn || null,
      }
      console.log('Payload:', payload)

      const endpoint = this.form.fixId ? `/fixUpdate/${this.form.fixId}` : '/fixAdd'
      try {
        const response = await apiAdmin[!this.form.fixId ? 'post' : 'put'](endpoint, payload)
        return response
      } catch (error) {
        console.error('Error saving fix:', error.response ? error.response.data : error.message)
        throw new Error(`เกิดข้อผิดพลาดในการบันทึก fix: ${error.message}`)
      }
    },

    async saveFixDetail() {
      if (!this.form.fixId) {
        console.error('fixId is null when saving fix detail')
        throw new Error('fixId ไม่มีค่า')
      }
      console.log('Current fixDetails:', JSON.stringify(this.form.fixDetails))

      const detailPayload = {
        detail: this.form.fixDetails.detail,
        order: this.form.order,
        fixDet: { id: this.form.fixId },
      }
      console.log('Detail Payload:', detailPayload)
      console.log('this.form.fixDetails.id:', this.form.fixDetails.id)
      const endpoint = this.form.fixDetails.id ? `/detailsUpdate/${this.form.fixDetails.id}` : '/detailsAdd'
      console.log('Endpointdetails:', endpoint)
      try {
        const response = await apiAdmin[this.form.fixDetails.id ? 'put' : 'post'](endpoint, detailPayload)
        console.log('Response from server:', response)
      } catch (error) {
        console.error('Error saving fix detail:', error.response ? error.response.data : error.message)
        throw error
      }
    },

    async saveFixDetailAdd() {
      if (!this.form.fixId) {
        console.error('fixId is null when saving additional fix detail')
        throw new Error('fixId ไม่มีค่า')
      }
      console.log('Current fixDetailsAdd:', JSON.stringify(this.form.fixDetailsAdditional))
      const detailAddPayload = {
        fixdetail: this.form.fixDetailsAdditional.fixdetail,
        order: this.form.order,
        fixDet: { id: this.form.fixId },
      }

      const endpoint = this.form.fixDetailsAdditional.id ? `/fixdetailsUpdate/${this.form.fixDetailsAdditional.id}` : '/fixdetailsAdd'

      try {
        await apiAdmin[this.form.fixDetailsAdditional.id ? 'put' : 'post'](endpoint, detailAddPayload)
      } catch (error) {
        console.error('Error saving fix detailAdd:', error.response ? error.response.data : error.message)
        throw error
      }
    },

    async savesolution() {
      if (!this.form.fixId) {
        console.error('fixId is null when saving solution save')
        throw new Error('fixId ไม่มีค่า')
      }
      const detailPayload = {
        soldetail: this.form.fixsolution.soldetail,
        order: this.form.order,
        fixDet: { id: this.form.fixId },
        user: { id: this.$store.getters.userId },
      }

      const endpoint = this.form.fixsolution.id ? `/fixsolutionUpdate/${this.form.fixsolution.id}` : '/fixsolutionAdd'

      try {
        await apiAdmin[this.form.fixsolution.id ? 'put' : 'post'](endpoint, detailPayload)
      } catch (error) {
        console.error('Error saving fix solution:', error.response ? error.response.data : error.message)
        throw error
      }
    },

    async saveExpense() {
      if (!this.expenseForm.expenseCateId || !this.expenseForm.expenseSubcateId) {
        this.isSubcategoryRequired = true
        console.error('กรุณากรอกข้อมูลหมวดหมู่ให้ครบถ้วน')
        return
      }

      const expensePayload = {
        device: { id: this.form.deviceId },
        expenseCate: { id: this.expenseForm.expenseCateId },
        expenseSubcate: { id: this.expenseForm.expenseSubcateId },
        cost: this.expenseForm.cost,
        note: this.expenseForm.note,
        quantity: this.expenseForm.quantity,
        unit: this.expenseForm.unit,
        fixDet: { id: this.form.fixId },
      }

      const endpoint = this.expenseForm.expensefixId
        ? `/expensefixUpdate/${this.expenseForm.expensefixId}`
        : '/expensefixAdd'

      try {
        const response = await apiAdmin[!this.expenseForm.expensefixId ? 'post' : 'put'](endpoint, expensePayload)
        if (response.status === 200 || response.status === 201) {
          console.log('Expense saved successfully:', response.data)
          this.expenseForm.expensefixId = response.data.id
          this.showExpenseModal = false
          await this.fetchExpensesfix()
          this.clearExpenseForm()
          this.isSubcategoryRequired = false
        }
      } catch (error) {
        console.error('Error saving expensefix:', error)
      }
    },

    async fetchSubcategories() {
      if (!this.form.categoryId) return

      this.isLoadingfix = true
      try {
        const response = await apiSetting.get(`/subcate/${this.form.categoryId}`)

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.subcategoriesOptions = response.data.map(sc => ({ value: sc.id, text: sc.name }))
        } else {
          this.subcategoriesOptions = []
          console.warn('ไม่พบหมวดหมู่ย่อย')
          this.$bvToast.toast(this.$t('notfoundsubcate'), {
            title: this.$t('warning'),
            variant: 'warning',
            solid: true,
          })
        }
      } catch (error) {
        console.error('Error fetching subcategories:', error)
        this.subcategoriesOptions = []
        this.$bvToast.toast(this.$t('getsubcatefailed'), {
          title: this.$t('error'),
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.isLoadingfix = false
      }
    },

    async fetchDevices() {
      if (!this.form.devicesubcategoryId) {
        this.devicesOptions = []
        return
      }

      this.isLoadingDevice = true
      try {
        const response = await apiMst.get(`/deviceList/${this.form.devicesubcategoryId}`)

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.devicesOptions = response.data.map(d => ({ value: d.id, text: d.deviceName }))
        } else {
          this.devicesOptions = []
          console.warn('ไม่พบอุปกรณ์')
          this.$bvToast.toast(this.$t('notfoundsubcateIndevice'), {
            title: this.$t('warning'),
            variant: 'warning',
            solid: true,
          })
        }
      } catch (error) {
        console.error('Error fetching devices:', error)
        this.devicesOptions = []

        this.$bvToast.toast(this.$t('getdevicefailed'), {
          title: this.$t('error'),
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.isLoadingDevice = false
      }
    },

    async fetchDeviceSubcategories() {
      if (!this.form.devicecategoryId) return

      this.isLoadingDeviceCate = true
      try {
        const response = await apiMst.get(`/subdevice/${this.form.devicecategoryId}`)

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.devicesubcategoriesOptions = response.data.map(dsc => ({ value: dsc.id, text: dsc.name }))
        } else {
          this.devicesubcategoriesOptions = []
          console.warn('ไม่พบหมวดหมู่ย่อยของอุปกรณ์')

          this.$bvToast.toast(this.$t('notfoundsubcateIndevice'), {
            title: this.$t('warning'),
            variant: 'warning',
            solid: true,
          })
        }
      } catch (error) {
        console.error('Error fetching device subcategories:', error)
        this.devicesubcategoriesOptions = []

        this.$bvToast.toast(this.$t('getsubcatedevicefailed'), {
          title: this.$t('error'),
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.isLoadingDeviceCate = false
      }
    },

    async fetchworker() {
      this.loadingWorker = true
      try {
        const response = await apiAuth.get(`/auth/showdata/roles/id/${3}`)
        this.workers = response.data.map(w => ({ value: w.id, text: w.username }))
      } catch (error) {
        console.error('Error fetching worker:', error)
      } finally {
        this.loadingWorker = false
      }
    },

    async fetchstatus() {
      try {
        const response = await apiMst.get('/status')
        if (Array.isArray(response.data) && response.data.length > 0) {
          const options = response.data.map(status => ({
            value: status.id,
            text: status.statusName || '',
          }))

          this.localStatusOptions = options
        } else {
          console.error('No status data found')
          this.localStatusOptions = []
        }
      } catch (error) {
        console.error('Error fetching statuses:', error)
      }
    },

    async fetchExpenses() {
      try {
        const categoryResponse = await apiMst.get('/expense/cate')
        const categories = categoryResponse.data

        this.expensesOptions = []

        categories.forEach(category => {
          this.expensesOptions.push({
            value: category.id,
            text: `${category.name}`,
            isCategory: true,
            subcate: category.expenseSubCate || [],
          })
        })

        this.formatOptions()
      } catch (error) {
        console.error('Error fetching expenses:', error)
      }
    },
    async fetchExpenseSubcate(categoryId, categoryOption) {
      try {
        const response = await apiMst.get(`/expense/subcate/${categoryId}`)
        const subcate = response.data

        console.log(`Subcategories for category ${categoryId}:`, subcate)

        if (Array.isArray(subcate)) {
          subcate.forEach(subcategory => {
            categoryOption.subcate.push({
              value: subcategory.id,
              text: `${subcategory.name}`,
              isCategory: false,
            })
          })
        } else {
          console.warn(`Subcate for category ${categoryId} is not an array`, subcate)
        }

        this.$set(this, 'expensesOptions', [...this.expensesOptions])
      } catch (error) {
        this.errorMessage = 'ไม่สามารถโหลดหมวดหมู่ย่อยได้. โปรดลองใหม่อีกครั้ง.'
        console.error(`Error fetching subcate for category ${categoryId}:`, error)
      }
    },

    async fetchLocations() {
      try {
        const response = await apiMst.get('/location')
        this.locations = response.data || []
      } catch (error) {
        console.error('Error fetching locations:', error)
      }
    },

    formatOptions() {
      this.formattedOptions = []

      this.expensesOptions.forEach(option => {
        this.formattedOptions.push({
          value: option.value,
          text: option.text,
          isCategory: true,
        })

        const sortedSubcategories = option.subcate.sort((a, b) => {
          const nameA = a.name.toLowerCase()
          const nameB = b.name.toLowerCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        })

        sortedSubcategories.forEach(sub => {
          this.formattedOptions.push({
            value: sub.id,
            text: `- ${sub.name}`,
            isCategory: false,
            categoryId: option.value,
          })
        })
      })
    },

    onCategoryChange() {
      const selectedCategory = this.expensesOptions.find(option => option.value === this.expenseForm.expenseCateId)
      if (selectedCategory) {
        this.expenseForm.expenseSubcateId = null
      }
    },

    onSubcategoryChange() {
      const selectedSubcategory = this.formattedOptions.find(option => option.value === this.expenseForm.expenseSubcateId && !option.isCategory)

      if (selectedSubcategory) {
        this.expenseForm.expenseCateId = selectedSubcategory.categoryId
        this.isSubcategoryRequired = false
      }
    },

    async fetchExpensesfix() {
      if (!this.form.fixId) return
      this.isLoading.expenses = true
      try {
        const response = await apiAdmin.get(`/expensefixList/${this.form.fixId}`)

        if (Array.isArray(response.data)) {
          this.expensesList = response.data.map(expense => ({
            expensefixId: expense.id,
            expenseCateId: expense.expenseCate?.id || null,
            expenseCateName: expense.expenseCate?.name || '',
            expenseSubcateName: expense.expenseSubcate?.name || '',
            note: expense.note || '',
            cost: expense.cost || 0,
            quantity: expense.quantity || '',
            unit: expense.unit || '',
            sum: expense.quantity * expense.cost,
          }))
        } else {
          console.warn('Expected an array but got:', response.data)
          this.expensesList = []
        }
      } catch (error) {
        console.error('Error fetching expenses:', error)
      } finally {
        this.isLoading.expenses = false
      }
    },

    async fetchspare() {
      if (!this.form.fixId) return
      this.isLoading.spares = true
      try {
        const response = await apiAdmin.get(`/sparelistByFixId/${this.form.fixId}`)

        if (Array.isArray(response.data)) {
          this.spareList = response.data.map((spare, index) => ({
            id: spare.id,
            orderlist: index + 1,
            list: spare.spList || '',
            purchase: spare.spPurchase || '',
            quantity: spare.spQuantity || '',
            cost: spare.spCost || 0,
            source: spare.spSource || '',
            detail: spare.spDetail || '',
          }))
        } else {
          console.warn('Expected an array but got:', response.data)
          this.spareList = []
        }
      } catch (error) {
        console.error('Error fetching spare:', error)
      } finally {
        this.isLoading.spares = false
      }
    },

    checkfixdetailsLength() {
      if (this.form.fixDetails.detail.length >= 150) {
        this.lengthfixdetailsExceeded = true
        this.form.fixDetails.detail = this.form.fixDetails.detail.slice(0, 150)
      } else {
        this.lengthfixdetailsExceeded = false
      }
    },

    checkfixdetailsAddLength() {
      if (this.form.fixDetailsAdditional.fixdetail.length >= 150) {
        this.lengthfixdetailsAddExceeded = true
        this.form.fixDetailsAdditional.fixdetail = this.form.fixDetailsAdditional.fixdetail.slice(0, 150)
      } else {
        this.lengthfixdetailsAddExceeded = false
      }
    },

    checkfixsolutionAddLength() {
      if (this.form.fixsolution.soldetail.length >= 150) {
        this.lengthfixsolutionExceeded = true
        this.form.fixsolution.soldetail = this.form.fixsolution.soldetail.slice(0, 150)
      } else {
        this.lengthfixsolutionExceeded = false
      }
    },

    checkexpenseLength() {
      if (this.expenseForm.note.length >= 50) {
        this.lengthexpenseExceeded = true
        this.expenseForm.note = this.expenseForm.note.slice(0, 50)
      } else {
        this.lengthexpenseExceeded = false
      }
    },
    checkspareLength() {
      if (this.spareForm.detail.length >= 50) {
        this.lengthspareExceeded = true
        this.spareForm.detail = this.spareForm.detail.slice(0, 50)
      } else {
        this.lengthspareExceeded = false
      }
    },

    checkcancelDetailsLength() {
      if (this.form.cancelDetails.length >= 50) {
        this.lengthcancelDetailsExceeded = true
        this.form.cancelDetails = this.form.cancelDetails.slice(0, 50)
      } else {
        this.lengthcancelDetailsExceeded = false
      }
    },
	
	async checkheadconfirm() {
      try {
        const response = await apiAdmin.get(`/headChecker/${this.form.order}`)
        const result = response.data

        const isConfirmed = !!result

        this.confirmedByhead = isConfirmed
        this.form.confirmedByhead = isConfirmed
      } catch (error) {
        console.error('Error fetching headchecker:', error)
      }
    },

    limitInputexpenseForm(event) {
      const maxLength = 15

      const inputValue = this.expenseForm.cost.toString()

      if (inputValue.length >= maxLength && event.key !== 'Backspace') {
        event.preventDefault()
      }

      if (inputValue.indexOf('.') !== -1) {
        const decimalPart = inputValue.split('.')[1]
        if (decimalPart && decimalPart.length >= 2 && event.key !== 'Backspace') {
          event.preventDefault()
        }
      }
    },

    limitQuantityInputexpenseForm(event) {
      const maxLength = 20

      const inputValue = this.expenseForm.quantity.toString()

      if (inputValue.length >= maxLength && event.key !== 'Backspace') {
        event.preventDefault()
      }

      if (inputValue.indexOf('.') !== -1) {
        const decimalPart = inputValue.split('.')[1]
        if (decimalPart && decimalPart.length >= 2 && event.key !== 'Backspace') {
          event.preventDefault()
        }
      }
    },

    limitInputspareForm(event) {
      const maxLength = 15

      const inputValue = this.spareForm.cost.toString()

      if (inputValue.length >= maxLength && event.key !== 'Backspace') {
        event.preventDefault()
      }

      if (inputValue.indexOf('.') !== -1) {
        const decimalPart = inputValue.split('.')[1]
        if (decimalPart && decimalPart.length >= 2 && event.key !== 'Backspace') {
          event.preventDefault()
        }
      }
    },

    isSum(cost) {
      return cost === this.$t('sum')
    },
    isSumList(list) {
      return list === this.$t('sum')
    },

    async fetchEmails(userId) {
      if (!userId) {
        throw new Error('User ID is required')
      }

      try {
        const response = await apiAuth.post('/email/searchuser', { userId })
        if (response.status === 200) {
          const match = response.data.match(/\[([^\]]+)\]/)
          if (match && match[1]) {
            return match[1].split(',').map(email => email.trim())
          }
          throw new Error('No emails found in API response')
        }
        throw new Error('Failed to fetch approver emails')
      } catch (error) {
        console.error('Error fetching approver emails:', error)
        throw error
      }
    },

    async fetchWorkerEmails() {
      try {
        const response = await apiAuth.post('/email/searchrolemail', { roleId: 3 })

        if (response.status === 200) {
          const emails = response.data
          if (Array.isArray(emails) && emails.length > 0) {
            return emails.map(email => email.trim())
          }
          throw new Error('No emails found in API response')
        }
        throw new Error('Failed to fetch worker emails')
      } catch (error) {
        console.error('Error fetching worker emails:', error)
        throw error
      }
    },

    async sendEmailNotification(emailData) {
      try {
        if (!emailData || emailData.length === 0) {
          throw new Error('Recipients list is empty')
        }

        const isTokenValid = emailservice.isTokenValid()
        if (!isTokenValid) {
          throw new Error('Please log in again to send emails')
        }
        const addjob = this.form && (this.form.statusId === 1 || this.form.statusId === 2 || this.form.statusId === 3)
        const finishjob = this.form && this.form.statusId === 5
        const canceljob = this.form && this.form.statusId === 4
        const orderId = this.form.order ?? 'N/A'
		const fixdetailsAdd = this.form.fixDetailsAdditional.fixdetail || 'N/A'
        const fixsolution = this.form.fixsolution.soldetail || 'N/A'
        const sn = this.form.sn || 'N/A'
        let requestTypeMessage = ''
        let titleName = ''
        let linkdetail = ''
        const username = this.getusernameById(this.form.userId) ?? 'N/A'
        if (finishjob) {
          requestTypeMessage = 'สถานะแจ้งซ่อมของท่านสำเร็จเเล้ว รบกวนทำเเบบประเมิณเพื่อนำไปพัฒนาให้กระบวนการทำงานได้มีประสิทธิภาพดียิ่งขึ้น แจ้งซ่อมของท่านมีรายละเอียดดังนี้:'
          titleName = `คุณ${username}`
          linkdetail = `https://mns.gelogs.co.th/request/search/${orderId}`
        } else if (canceljob) {
          requestTypeMessage = 'สถานะการแจ้งซ่อมของท่านได้ถูกยกเลิกแล้ว มีรายละเอียดดังนี้:'
          titleName = `คุณ${username}`
          linkdetail = `https://mns.gelogs.co.th/request/search/${orderId}`
        } else if (addjob) {
          requestTypeMessage = 'ขอความอนุเคราะห์เพื่อดำเนินการซ่อมต่อไป มีรายละเอียดดังนี้:'
          titleName = 'ฝ่ายเทคโนโลยีสารสนเทศและกิจการทั่วไป'
          linkdetail = `https://mns.gelogs.co.th/admin/search/${orderId}`
        }

        const emailTemplate = `
      <!DOCTYPE html>
      <html>
      <body>
        <p style="font-size: 18px;">เรียน <strong>${titleName}</strong>,</p>
        <p>${requestTypeMessage}</p>
          <ul>
          <li>หมายเลขแจ้งซ่อม: ${this.form.order ?? 'N/A'}</li>
          <li>ผู้แจ้งซ่อม: ${username}</li>
          <li>แจ้งซ่อมเวลา: ${this.formatDate(new Date(), 'short')}</li>
          <li>หมวดหมู่ปัญหา: ${this.getCategoryNameById(this.form.categoryId)}</li>
          <li>หมวดหมู่ปัญหาย่อย: ${this.getSubcategoryNameById(this.form.subcategoryId)}</li>
          <li>สถานที่: ${this.getlocationNameById(this.form.locationId)}</li>
          <li>หมายเลขประจำเครื่อง(S/N): ${sn}</li>
          <li>รายละเอียดปัญหา: ${this.form.fixDetails.detail}</li>
          <li>รายละเอียดสาเหตุ: ${fixdetailsAdd}</li>
          <li>รายละเอียดวิธีแก้ไข: ${fixsolution}</li>
        </ul>
        <p>ท่านสามารถคลิกลิงก์นี้เพื่อดูรายละเอียดเพิ่มเติม:<a href=${linkdetail}>ดูรายละเอียดการแจ้งซ่อม</a></p>
        <p>ขอแสดงความนับถือ</p>
      </body>
      </html>
    `

        await emailservice.sendEmailWithTemplate(emailData, emailTemplate, {
          subject: `รายละเอียดการแจ้งซ่อม (${this.form.order ?? 'N/A'})`,
        })
      } catch (error) {
        console.error('Error sending email:', error)
        throw error
      }
    },

    getCategoryNameById(id) {
      const category = this.categoriesOptions.find(c => c.value === id)
      return category ? category.text : 'N/A'
    },

    getSubcategoryNameById(id) {
      const subcategory = this.subcategoriesOptions.find(sc => sc.value === id)
      return subcategory ? subcategory.text : 'N/A'
    },

    getlocationNameById(id) {
      const location = this.locationsOptions.find(d => d.value === id)
      return location ? location.text : 'N/A'
    },

    getusernameById(id) {
      const user = this.users.find(c => c.id === id)
      return user ? user.username : 'N/A'
    },
	
	formatDate(date, formatType = 'short') {
	  const options = { 
		year: 'numeric', 
		month: formatType === 'short' ? 'short' : 'long',
		day: 'numeric' 
	  }
    const formatter = new Intl.DateTimeFormat('en-GB', options)
    return formatter.format(date)
    },
  }
}
</script>

<style scoped>
.form-section {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
  flex: 1;
  white-space: nowrap;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-row .b-form-group {
  flex: 1;
}

.section-title {
  background-color: #4a6a8c;
  color: white;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
}

.form-buttons {
  margin-top: 15px;
  display: flex;
  gap: 20px;
  justify-content: flex-end;
}
.input-box{
  width: 28vw;
  height: 35px;
}

.input-image{
  width: 400px;
  height: 50px;
}

.input-text{
  width: 21vw;
  height: 150px;
  resize: none;
}

.btn-space{
  margin: 3px;
}

.input-textcancel{
  width: 400px;
  height: 60px;
  resize: none;
}

.form-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap
}

.form-section {
  flex: 1;
  min-width: 300px;
  max-width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.b-spinner {
  color: white;
}

.loading-container {
  text-align: center;
  color: #fff;
}

.category-option {
  background-color: #949494; /* ฟ้าสดใส */
  color: white;
  font-weight: bold;
}

.subcategory-option {
  background-color: transparent; /* ไม่มีการเปลี่ยนแปลงพื้นหลัง */
}

@media (max-width: 486px) {
  .form-container {
    flex-direction: column; /* แสดงในแนวตั้งบนหน้าจอเล็ก */
  }
  .input-text {
    overflow-y: auto; /* แสดงแถบเลื่อนแนวตั้งเมื่อข้อความเกิน */
    overflow-x: hidden; /* ปิดแถบเลื่อนแนวนอน */
    white-space: normal; /* ป้องกันการตัดข้อความในแนวนอน */
    width: 220px;
    height: 150px;
    resize: none;
  }
  .input-image{
  width: 100%;
  height: 50px;
  }
  .input-box {
  width: 20vw;
  height: 40px;
  }

}
@media (max-width: 360px) {
  .input-textcancel{
  width: 300px;
  height: 60px;
  resize: none;
}
}
</style>
